<template>
    <span class="count-badge" v-bind="$attrs">{{ value }}</span>
</template>

<script>
export default {
    name: "CountBadge",

    props: {
        value: { type: [String, Number], default: "" },
    },
};
</script>

<style lang="scss" scoped>
.count-badge {
    display: inline-flex;
    font-size: 12px;
    line-height: 110%;
    margin-right: 4px;
    border: 1px solid #e5e5e5;
    padding: 2px 5px;
    border-radius: 50%;
    color: #757676;
    background: #f8fafc;
    color: #1A202C;
    background: #e3f2f4;
}
</style>